exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ll-info[data-v-5e203372] {\n  cursor: pointer;\n}\n", ""]);

// exports
